import * as React from "react";
export const wrapRootElement = ({ element }) => <>{element}</>;
